
import { Component, Model, Prop } from 'vue-property-decorator'
import BaseInput from './BaseInput.vue'

@Component({
  inheritAttrs: false,
})
export default class BaseRadio extends BaseInput {
  @Prop()
    disabled!: boolean

  @Model('input')
    modelValue!: string

  get isChecked() {
    // eslint-disable-next-line no-prototype-builtins
    return this.$attrs.hasOwnProperty('checked')
      ? !!this.$attrs.checked
      : this.value === this.modelValue
  }

  onChange() {
    this.$emit('input', this.value)
  }
}
